var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgWorkspaceBigCrmcomponent = function SvgWorkspaceBigCrmcomponent(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 37 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.802 4.365c-3.015-3.015-7.53-3.63-11.16-1.86l6.51 6.51-4.5 4.5-6.51-6.51c-1.755 3.645-1.14 8.13 1.875 11.145 2.79 2.79 6.87 3.525 10.335 2.22l13.665 13.665c.585.585 1.53.585 2.115 0l3.45-3.45a1.494 1.494 0 0 0 0-2.115L20.977 14.85c1.38-3.51.66-7.65-2.175-10.485Z",
    fill: "current"
  })));
};
export default SvgWorkspaceBigCrmcomponent;